import Reveal from '../../../shared/Reveal/Reveal';
import { useInfrastructureProtocolsContent } from '../../../../hooks/useInfrastructureProtocolsContent';
import protocolsImage from '../../../../assets/images/infrastructure/protocols/main.jpg';
import './Protocols.css';

const Protocols = () => {
  const { content, isLoading } = useInfrastructureProtocolsContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, paragraphs, image } = content;

  return (
    <section className="infrastructure-protocols">
      <div className="infrastructure-protocols__inner">
        <Reveal className="infrastructure-protocols__media">
          <img
            className="infrastructure-protocols__image"
            src={image || protocolsImage}
            alt=""
            aria-hidden="true"
          />
        </Reveal>

        <Reveal className="infrastructure-protocols__copy" delay={80}>
          <h2 className="infrastructure-protocols__title">{title}</h2>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="infrastructure-protocols__text">
              {paragraph}
            </p>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Protocols;
